import React from 'react';
import PropTypes from 'prop-types';

import {FilterItemCheckbox, FilterItemDropdown} from '../filters/filterItemComponent';

export default class Filter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            filterType: props.filterType || 'checkbox'
        };
    }

    render() {
        if(this.state.filterType === 'checkbox'){
            return <FilterItemCheckbox {...this.props}/>;
        }
        if(this.state.filterType === 'dropdown'){
           return <FilterItemDropdown {...this.props}/>;
        }
    }

}

Filter.propTypes = {
    filterType: PropTypes.string
};